import { styled } from "styled-components";

import { useDeleteTopicMutation } from "api/topicsApi.slice";
import { StyledModalText, UIButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";

const StyledMapTitle = styled.div`
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.modalCardBackground};
  border-radius: 5px;
  margin-bottom: 20px;
`;

export const ConfirmDeleteMapModal = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const { name, topicId } = useSelector(getModalParams) as ModalParams<"ConfirmDeleteMap">;
  const track = useTrack();
  const translate = useTranslate();

  const [deleteTopic] = useDeleteTopicMutation();

  const handleYes = () => {
    if (!topicId) {
      return;
    }
    void deleteTopic({ topic_id: topicId });
    track({ entityId: topicId, entityType: "Custom Map", name: "Delete map", page: "Create landing" });
    dispatch(deactivateModal());
    go("/create");
  };

  return (
    <>
      <ModalHeader title={translate("app.create.delete.modal_title")} />
      <StyledModalText>{translate("app.create.delete.title")}</StyledModalText>
      <StyledMapTitle>{name}</StyledMapTitle>
      <UIButton data-test-id="confirm-deleting-custom-map-button" error fullwidth onClick={handleYes}>
        {translate("app.create.delete.confirm")}
      </UIButton>
    </>
  );
};
